import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import DemoComponent from "../components/DemoComponent/Demo.component";
import EnergyImg from './../utils/resources/DemoIcons/Energy.png'
import IndustrialImg from './../utils/resources/DemoIcons/Industrial.png'
import WaterImg from './../utils/resources/DemoIcons/Water.png'
import VendingImg from './../utils/resources/DemoIcons/Vending.png'


const DemosPage = () => {
    const { t } = useTranslation();
    const context: IOutletContext = useOutletContext();


    const demosLinks = [
        {
            name: t('Industrial'),
            route: 'home',
            icon: IndustrialImg,
            page: false
        },
        {
            name: t('Energy'),
            route: 'https://energy.awayter.com',
            icon: EnergyImg,
            page: true
        },
        {
            name: t('Water'),
            route: 'https://water.awayter.com/',
            icon: WaterImg,
            page: true
        },
        {
            name: t('Vending'),
            route: 'https://app.awayter.com/',
            icon: VendingImg,
            page: true
        }]


    useEffect(() => {
        context.setState(t('Demos'));
    }, [context, t]);


    const containerStyle: React.CSSProperties = {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        gap: '1.25rem',
        justifyContent: "center"
    }

    return (
        <div className="p-3">
            <div style={containerStyle}>
                {
                    demosLinks.map((m, k) =>
                        <DemoComponent key={k} icon={m.icon} name={m.name} route={m.route} page={m.page} />
                    )
                }
            </div>
        </div>
    );
};

export default DemosPage;
